import React, { useContext } from "react";
import { Paper, Typography, Stack, Grid } from "@mui/material";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import {
  faCalendar,
  faCalendarCheck,
  faCalendarXmark,
  faCoins,
  faHandHoldingDollar,
  faMoneyBillTrendUp,
  faSackDollar,
  faUserCheck,
  faUsers,
  faWallet,
  faChartSimple,
  faHouseLaptop,
} from "@fortawesome/free-solid-svg-icons";
import CallerSelector from "../../components/CallerSelector";
import SelectorClientsGestor from "./selectores/selectoresCartera/SelectorClientsGestor";
import SelectorCreditsByGestor from "./selectores/selectoresCartera/SelectorCreditsByGestor";
import SelectorCobroDiario from "./selectores/selectoresCartera/SelectorCobroDiario";
import SelectorRecuperacion from "./selectores/selectoresCartera/SelectorRecuperacion";
import SelectorDesembolsos from "./selectores/selectoresCartera/SelectorDesembolsos";
import SelectorSaldosCartera from "./selectores/selectoresCartera/SelectorSaldosCartera";
import SelectorCreditosVencidos from "./selectores/selectoresCartera/SelectorCreditosVencidos";
import SelectorAccountStatus from "./selectores/selectoresCartera/SelectorAccountStatus";
import SelectorCreditsCancelled from "./selectores/selectoresCartera/SelectorCreditsCancelled";
import SelectorVencimientosProyectados from "./selectores/selectoresCartera/SelectorVencimientosProyectados";
import SelectorIngresosFinancieros from "./selectores/selectoresCartera/SelectorIngresosFinancieros";
import SelectorGarantias from "./selectores/selectoresCartera/SelectorGarantias";
import { DataContext } from "../../context/DataContext";
import { isAccess } from "../../helpers/Helpers";

const Reports = () => {
  const { access } = useContext(DataContext);
  return (
    <div>
      <Paper sx={{ padding: "22px 24px", marginBottom: "16px" }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ marginBottom: "18px" }}>
          <AccountBalanceWalletRoundedIcon sx={{ fontSize: 20, color: "success.main" }} />
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Reportes de cartera</Typography>
        </Stack>

          <Grid container spacing={2} justifyContent="center">
            {isAccess(access, "RCLIENTS") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faUsers}
                  text="Reporte de Clientes"
                  modalTitle="Reporte de Clientes"
                >
                  <SelectorClientsGestor />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <CallerSelector
                icon={faHouseLaptop}
                text="Reporte de Garantias"
                modalTitle="Reporte de Garantias"
              >
                <SelectorGarantias />
              </CallerSelector>
            </Grid>

            {isAccess(access, "RCREDXGEST") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faHandHoldingDollar}
                  text="Créditos por Gestor"
                  modalTitle="Créditos por Gestor"
                >
                  <SelectorCreditsByGestor />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
            {isAccess(access, "RCOBDIARIO") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faCalendarCheck}
                  text="Cobro Diario"
                  modalTitle="Cobro Diario"
                >
                  <SelectorCobroDiario />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
            {isAccess(access, "RECUPERAC") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faUserCheck}
                  text="Recuperación"
                  modalTitle="Reporte de Recuperacion"
                >
                  <SelectorRecuperacion />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}

            {isAccess(access, "RECUPERAC") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faChartSimple}
                  text="Ingresos Financieros"
                  modalTitle="Ingresos Financieros"
                >
                  <SelectorIngresosFinancieros />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}

            {isAccess(access, "RDESEMBOLSO") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faWallet}
                  text="Desembolsos"
                  modalTitle="Reporte de Desembolsos"
                >
                  <SelectorDesembolsos />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
            {isAccess(access, "RSALCART") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faCoins}
                  text="Saldos Cartera"
                  modalTitle="Reporte Saldos Cartera"
                >
                  <SelectorSaldosCartera />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
            {isAccess(access, "RCREDVENC") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faCalendarXmark}
                  text="Créditos Vencidos"
                  modalTitle="Reporte Créditos Vencidos"
                >
                  <SelectorCreditosVencidos />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
            {isAccess(access, "RVENCPROY") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faCalendar}
                  text="Vencimientos Proyectados"
                  modalTitle="Reporte Vencimientos proyectados"
                >
                  <SelectorVencimientosProyectados />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
            {isAccess(access, "RCREDCANC") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faMoneyBillTrendUp}
                  text="Créditos Cancelados"
                  modalTitle="Reporte Créditos Cancelados"
                >
                  <SelectorCreditsCancelled />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
            {isAccess(access, "RACCOUNTSTS") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faSackDollar}
                  text="Estado de Cuenta"
                  modalTitle="Reporte de Estado de Cuenta"
                >
                  <SelectorAccountStatus />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </Paper>
    </div>
  );
};

export default Reports;
